import React, { useState } from "react";
import { useLocation } from "react-router-dom";
// import { useEffect } from "react/cjs/react.development";
import { useEffect } from "react";
import jsonData from "../A2PI.json";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import Marquee from "react-fast-marquee";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  main: {
    width: "85%",
    margin: "0 auto",
    marginBottom: "2rem",
  },
  details: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
  },
  btnStyle: {
    margin: "1rem",
    backgroundColor: "#056EF2",
  },
  over: {
    marginLeft: "7.5%",
    marginRight: "auto",
    display: "flex",
  },
  doc: {
    backgroundColor: "#056EF2",
    marginBottom: "2rem",
    alignSelf: "left",
    marginRight: "1rem",
   
  },
}));

function RenderData(props) {
  const classes = useStyles();
  const location = useLocation();
  const path = location.pathname;
  const [grade, setGrade] = useState("");
  const [sessionNumber, setSessionNumber] = useState("");

  const [tech, setTech] = useState("");
  const [newData, setNewData] = useState([]);
  const [newLinks, setNewLinks] = useState(["1", "2", "3"]);
  const newpath = `${path}`.split("/");
  const [m1Style, setM1Style] = useState({});
  const [m2Style, setM2Style] = useState({ display: "none" });
  const [level, setLevel] = useState("1");
  const [session, setSession] = useState("1");
  const [school, setSchool] = useState(false);
  // const [amazon, setAmazon] = useState(false);


  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    // console.log("path changed");
    const data = jsonData.filter((f) => {
      return path === "/1to1"
        ? f.type === "1to1"
        : path === "/1ton"
        ? f.type === "1ton"
        : path === "/school"
        ? f.type === "school"
        : path
        ? // : path === path

          f.path === path
        : f.country;
    });
    setNewData(data);
  }, [path]);

  const Drops1 = [
    ...new Set(
      newData.map((ln) => {
        return ln.sessionNumber;
        // console.log('hii',ln.sessionNumber)
      })
    ),
  ];


  const Drops2 = [
    ...new Set(
      newData.map((ln) => {
        return ln.grade;
      })
    ),
  ];
  
  const secondData = newData.filter((i) => {
    return i.grade === grade && i.tech === tech && i.sessionNumber === sessionNumber;
  });

  const thirdData = newData.filter((t) => {
    return t.grade === grade && t.sessionNumber === sessionNumber;
  });

  // const firstData= newData.filter((t) => {
  //   return t.sessionNumber === sessionNumber;
  // });

  // console.log(thirdData, "from third data");
  return (
    <>
      <div
        className="filter-breadcrumb"
        style={path === "/" ? { display: "none" } : {}}
      >
        <div className="breadcrumb">
          <h2>{newpath[1]}</h2>

          {newpath[2] ? <h2>{">"}</h2> : <></>}
          <h2>{newpath[2]}</h2>

          {grade ? <h2>{">"}</h2> : <></>}
          <h2>{grade}</h2>
          {tech ? <h2>{">"}</h2> : <></>}

          <h2>{tech}</h2>
        </div>
        <div className="filters">

        <select
        name="session"
        id="session"
        placeholder="Session"
        onChange={(e) => {
        
          setSessionNumber(e.target.value);
        }}
        onClick={(e) => setSessionNumber(e.target.value)}
      >
        <option value="">Select Session</option>
        {Drops1.map((d) => {
          return (
            <option key={d} value={d}>
              {" "}
              {d}{" "}
            </option>
          );
        })}
         
       
      </select>

          <select
            name="grade"
            id="grade"
            placeholder="Grade"
            onChange={(e) => {
            
              setGrade(e.target.value);
            }}
            onClick={(e) => setGrade(e.target.value)}
          >
            <option value="">Select Grade</option>
            {Drops2.map((d) => {
              return (
                <option key={d} value={d}>
                  {" "}
                  {d}{" "}
                </option>
              );
            })}
          </select>

          <select
            name="tech"
            id="tech"
            onChange={(e) => {
             
              setTech(e.target.value);
            }}
            onClick={(e) => setTech(e.target.value)}
          >
            <option value="">Select Tech</option>
            {thirdData.map((d) => {
              return (
                <option key={d.tech} value={d.tech}>
                  {" "}
                  {d.tech}{" "}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <div className="main">
        {!grade || !tech ? (
          <>
            {
              <div className="info">
                <h1>Campk12 Resources Hub</h1>

                <h3>
                  Level Wise and Session Wise Project Links, One Pagers and
                  Slides.
                </h3>
                <div className="note">
                  <h4>
                    {" "}
                    <span>INSTRUCTIONS</span>
                  </h4>

                  <p className="list">
                    {" "}
                    <span></span> Choose the Session Type{" "}
                    <strong>(1:1 or 1:N)</strong>, then <strong>Country</strong>{" "}
                    , then select the <strong> grade</strong> and finally select
                    the <strong>Technology</strong> .
                  </p>
                  <p className="list">
                    <span></span> Instructors are requested to fill{" "}
                    <strong>Instructors Feedback/Queries</strong> in the top
                    right corner of the website for any feedback regarding
                    curriculum or resources and any content related queries.
                  </p>

                  <br />

                  <p className="notee">
                 
                    <h4 style={{fontSize:"19px"}}><img id="eye" src="http://cdn.shopify.com/s/files/1/1061/1924/products/Eyes_Emoji_grande.png?v=1571606063" alt="eye" width="30px"  ></img>Important Announcement - Regarding Global Demo Content [ME + Saudi]
                    </h4>
                    <Marquee gradientColor="0,255,0" speed="80">
                      {" "}
                      <div className="rotate" style={{ marginLeft: "1rem" }}>
                        {" "}
                     
                      </div>
                    </Marquee>
                    If you are taking demos of countries other than India, US  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://bit.ly/ME_DemoUpdates_AllGrades"
                  >
                    
                     Click here
                  </a>
                 
                  to know the demo content Updations.
                  </p>
                 <div className="halloween">
                 <div className="overlay2">
                 <h2> Exciting Update for India & ME - Diwali Demos!</h2>
                 <p>
                
                    Campk12 is celebrating Diwali Week with our India & ME demo students by creating Diwali-themed projects and the instructors are requested to teach these from now  till 5th of November.
                     You can find these updated projects in a separate section - Diwali Special  Demos.
                     Have a safe and prosperous Diwali! <span> 🪔🎆🌟🎇🧨✨🪔</span> 
                 </p>
                 </div>
                
                 </div>
                </div>
              </div>
            }
          </>
        ) : (
          <>
            {secondData.map((i) => {
              // console.log(i);
              // {i.path=='/School/Webinar'}
              return (
                <div>
                  {i.path === "/School/Webinar" ? (
                    <div className="webinarBox">
                      <a
                        href={i.link1}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="webBox"
                      >
                        Project
                      </a>
                      <a
                        href={i.link2}
                        className="webBox"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Project Template
                      </a>
                      <a
                        href={i.link3}
                        className="webBox"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        Slide
                      </a>
                    </div>
                  ) : i.path === "/School/Bootcamp" ? (
                    <div className="bootcamp">
                      <h4> {` ${i.grade} - ${i.tech}  `}</h4>

                      {i.links1
                        ? i.links1.map((l1, index) => {
                            return (
                              <Button
                                key={index}
                                variant="contained"
                                onClick={(e) => {
                                 
                                  setNewLinks([...l1.link]);
                                  setM1Style({ display: "none" });
                                  setM2Style({ display: "flex" });
                                  setLevel("School");
                                  setSession(index + 1);
                                  setSchool(true);
                                }}
                                className={classes.btnStyle}
                                color="primary"
                              >
                                Session-{index + 1}
                              </Button>
                            );
                          })
                        : "Curriculum Under Construction"}
                    </div>
                  ) :  i.path === "/Amazon" ? (
                    <div className="bootcamp">
                   
                      <h4> {` ${i.grade} - ${i.tech}  `}</h4>
                      <div>
                      <Button
                      className={classes.btnStyle}
                      color="primary"
                      variant="contained"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={i.assessment}
                      >Assessment</Button>
                      </div>
                      {i.links1
                        ? i.links1.map((l1, index) => {
                            return (
                              <Button
                                key={index}
                                variant="contained"
                                onClick={(e) => {
                                 
                                  setNewLinks([...l1.link]);
                                  setM1Style({ display: "none" });
                                  setM2Style({ display: "flex" });
                                  setLevel("Amazon Curriculum");
                                  setSession(index + 1);
                                }}
                                className={classes.btnStyle}
                                color="primary"
                              >
                                Session-{index + 1}
                              </Button>
                            );
                          })
                        : "Curriculum Under Construction"}
                    </div>
                  ) : (
                    <div className="main-1" key={i} style={m1Style}>
                      <div className={classes.over}>
                        {i.doc ? (
                          <Button
                            variant="contained"
                            className={classes.doc}
                            color="primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={i.doc}
                          >
                            Overview Document
                          </Button>
                        ) : (
                          ""
                        )}
                        {i.slide ? (
                          <div>
                            <Button
                              variant="contained"
                              className={classes.doc}
                              color="primary"
                              target="_blank"
                              rel="noopener noreferrer"
                              href={i.slide}
                            >
                              Course Overview Slide
                            </Button>
                          </div>
                        ) : (
                          ""
                        )}
                        {i.tutorial ? (
                          <Button
                            variant="contained"
                            className={classes.doc}
                            color="primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={i.tutorial}
                          >
                            Video Tutorials
                          </Button>
                        ) : (
                          ""
                        )} {i.scode ? (
                          <Button
                            variant="contained"
                            className={classes.doc}
                            color="primary"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={i.scode}
                          >
                            Source Code
                          </Button>
                        ) : (
                          ""
                        )}
                      </div>

                      <Accordion
                        className={classes.main}
                        expanded={expanded === "panel1"}
                        onChange={handleChange("panel1")}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography className={classes.heading}>
                            Demo -{" "}
                            {` ( ${i.country} - ${i.grade} - ${i.tech} ) - ${
                              i.demoName1 ? i.demoName1 : ""
                            } `}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.details}>
                          {i.demo
                            ? i.demo.map((l1, index) => {
                                return (
                                  <Button
                                    key={index}
                                    variant="contained"
                                    onClick={(e) => {
                                      // console.log(l1);
                                    }}
                                    className={classes.btnStyle}
                                    color="primary"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={l1}
                                  >
                                    {index === 0
                                      ? "Project"
                                      : index === 1
                                      ? "Project Template"
                                      : index === 2
                                      ? "One Pager"
                                      : index === 3
                                      ? "Slides"
                                      : index === 4
                                      ? "Explainer Video"
                                      : "Parent Conversation"}
                                  </Button>
                                );
                              })
                            : "Curriculum Under Construction"}
                        </AccordionDetails>
                      </Accordion>
                      {i.demo2 ? (
                        <Accordion
                          className={classes.main}
                          expanded={expanded === "panel5"}
                          onChange={handleChange("panel5")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography className={classes.heading}>
                              Demo -{" "}
                              {` ( ${i.country} - ${i.grade} - ${i.tech} ) - ${i.demoName2} `}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className={classes.details}>
                            {i.demo2
                              ? i.demo2.map((l1, index) => {
                                  return (
                                    <Button
                                      key={index}
                                      variant="contained"
                                      onClick={(e) => {
                                        // console.log(l1);
                                      }}
                                      className={classes.btnStyle}
                                      color="primary"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={l1}
                                    >
                                      {index === 0
                                        ? "Project"
                                        : index === 1
                                        ? "Project Template"
                                        : index === 2
                                        ? "One Pager"
                                        : index === 3
                                        ? "Slides"
                                        : index === 4
                                        ? "Explainer Video"
                                        : "Parent Conversation"}
                                    </Button>
                                  );
                                })
                              : "Curriculum Under Construction"}
                          </AccordionDetails>
                        </Accordion>
                      ) : (
                        ""
                      )}

                      {i.demo3 ? (
                        <Accordion
                          className={classes.main}
                          expanded={expanded === "panel6"}
                          onChange={handleChange("panel6")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography className={classes.heading}>
                              Demo -{" "}
                              {` ( ${i.country} - ${i.grade} - ${i.tech} ) - ${i.demoName3} `}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className={classes.details}>
                            {i.demo3
                              ? i.demo3.map((l1, index) => {
                                  return (
                                    <Button
                                      key={index}
                                      variant="contained"
                                      onClick={(e) => {
                                        // console.log(l1);
                                      }}
                                      className={classes.btnStyle}
                                      color="primary"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={l1}
                                    >
                                      {index === 0
                                        ? "Project"
                                        : index === 1
                                        ? "Project Template"
                                        : index === 2 
                                        ? "One Pager"
                                        : index === 3
                                        ? "Slides"
                                        : "Explainer Video" }
                                    </Button>
                                  );
                                })
                              : "Curriculum Under Construction"}
                          </AccordionDetails>
                        </Accordion>
                      ) : (
                        ""
                      )}
                      {i.demo4 ? (
                        <Accordion
                          className={classes.main}
                          expanded={expanded === "panel7"}
                          onChange={handleChange("panel7")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography className={classes.heading}>
                              Demo -{" "}
                              {` ( ${i.country} - ${i.grade} - ${i.tech} ) - ${i.demoName4} `}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className={classes.details}>
                            {i.demo3
                              ? i.demo3.map((l1, index) => {
                                  return (
                                    <Button
                                      key={index}
                                      variant="contained"
                                      onClick={(e) => {
                                        // console.log(l1);
                                      }}
                                      className={classes.btnStyle}
                                      color="primary"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={l1}
                                    >
                                      {index === 0
                                        ? "Project"
                                        : index === 1
                                        ? "Project Template"
                                        : index === 2 
                                        ? "Explainer Video"
                                        : "Intro to Metaverse" }
                                    </Button>
                                  );
                                })
                              : "Curriculum Under Construction"}
                          </AccordionDetails>
                        </Accordion>
                      ) : (
                        ""
                      )}
                    
                      <Accordion
                        className={classes.main}
                        expanded={expanded === "panel2"}
                        onChange={handleChange("panel2")}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography className={classes.heading}>
                            Level-1 -{" "}
                            {` ( ${i.country} - ${i.grade} - ${i.tech} ) `}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.details}>
                          {i.links1
                            ? i.links1.map((l1, index) => {
                                return (
                                  <Button
                                    key={index}
                                    variant="contained"
                                    onClick={(e) => {
                                      console.log(e);
                                      setNewLinks([...l1.link]);
                                      setM1Style({ display: "none" });
                                      setM2Style({ display: "flex" });
                                      setLevel("1");
                                      setSession(index + 1);
                                      setSchool(false);
                                    }}
                                    className={classes.btnStyle}
                                    color="primary"
                                  >
                                    {index === 12
                                      ? "Session 13(PTM)"
                                      : `Session-${index + 1}`}
                                  </Button>
                                );
                              })
                            : "Curriculum Under Construction"}
                        </AccordionDetails>
                      </Accordion>
                      <Accordion
                        className={classes.main}
                        expanded={expanded === "panel3"}
                        onChange={handleChange("panel3")}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography className={classes.heading}>
                            Level 2-{" "}
                            {` ( ${i.country} - ${i.grade} - ${i.tech} ) `}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.details}>
                          {i.links2
                            ? i.links2.map((l1, index) => {
                                // console.log(l1)
                                return (
                                  <Button
                                    key={index}
                                    variant="contained"
                                    onClick={(e) => {
                                      setNewLinks([...l1.link]);
                                      setM1Style({ display: "none" });
                                      setM2Style({ display: "flex" });
                                      setLevel("2");
                                      setSession(index + 1);
                                      setSchool(false);
                                    }}
                                    className={classes.btnStyle}
                                    color="primary"
                                  >
                                    {index === 12
                                      ? "Session 13(PTM)"
                                      : `Session-${index + 1}`}
                                  </Button>
                                );
                              })
                            : "Curriculum Under Construction"}
                        </AccordionDetails>
                      </Accordion>
                      <Accordion
                        className={classes.main}
                        expanded={expanded === "panel4"}
                        onChange={handleChange("panel4")}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography className={classes.heading}>
                            Level 3 -{" "}
                            {` ( ${i.country} - ${i.grade} - ${i.tech} ) `}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.details}>
                          {i.links3
                            ? i.links3.map((l1, index) => {
                                return (
                                  <Button
                                    key={index}
                                    variant="contained"
                                    onClick={(e) => {
                                      setNewLinks([...l1.link]);
                                      setM1Style({ display: "none" });
                                      setM2Style({ display: "flex" });
                                      setLevel("3");
                                      setSession(index + 1);
                                      setSchool(false);
                                    }}
                                    className={classes.btnStyle}
                                    color="primary"
                                  >
                                    {index === 12
                                      ? "Session 13(PTM)"
                                      : `Session-${index + 1}`}
                                  </Button>
                                );
                              })
                            : "Curriculum Under Construction"}
                        </AccordionDetails>
                      </Accordion>

                      <br />
                      <br />
                    </div>
                  )}
                </div>
              );
            })}
          </>
        )}
        {
          <div className="main-2" style={m2Style}>
            <div
              className="back-btn"
              onClick={() => {
                setM2Style({ display: "none" });
                setM1Style({ display: "flex" });
              }}
            >
              <i className="ri-arrow-left-circle-line"></i>
            </div>
            <div className="levelInfo">
              <h3>
                Level- {level} <span>Session- {session}</span>
              </h3>
            </div>

            {newLinks.map((n, i) => {
            //  {console.log(newLinks,'hiii')}
              return (
                <>
                  <div className="amazon-box"  key={Math.random()}>
                    <a href={n}  target="_blank" rel="noopener noreferrer">
                      <div className="amazon-arrow" style={{fontSize:'12px'}}>
                        {newLinks.length === 1
                          ? "PTM Modules"
                          : school
                          ? i === 0
                            ? "Project"
                            : i === 1
                            ? "Videos"
                            : "Slides"
                            : newLinks.length === 4
                            ? i === 0
                            ? "Project"
                            : i === 1
                            ? "In-class Slides"
                            :i === 2 
                            ? "Student Slides"
                            : "Videos"

                          : i === 0
                          ? "Project"
                          : i === 1
                          ? "One Pager"
                          : i === 2
                          ? "In Class Slides"
                          : i === 3
                          ? "Student Slides"
                          : "Explainer Videos"}
                      </div>
                    </a>
                  </div>
                </>
              );
            })}
          </div>
        }
      </div>
    </>
  );
}

//Iske div ne bht takleef diya hai

export default RenderData;
